<template>
  <div class="hdcgthtsx">
    <div class="title">合同筛选</div>
    <hdcgthsele class="hdsele" @change="yjchange" :list="classifylist" />
    <hdcgthsele
      class="hdsele"
      ref="ejfl"
      v-if="classifylist[ifyact] && classifylist[ifyact].children"
      label="二级分类"
      @change="changetag"
      :list="classifylist[ifyact].children || []"
    />
  </div>
</template>

<script>
import hdcgthsele from "../components/hdcgthsele";
export default {
  components: {
    hdcgthsele,
  },
  data: () => ({
    classifylist: [],
    ifyact: 0,
  }),
  beforeMount() {
    this.gethtlist();
  },
  methods: {
    changetag(e) {
      this.$store.commit(
        "jpcol/uphdcolId",
        this.classifylist[this.ifyact].children[e].id
      );
    },
    yjchange(e) {
      this.ifyact = e;
      let current = this.classifylist[this.ifyact];
      this.$nextTick(() => {
        this.$refs.ejfl.activindex = -1;
      });
      this.$store.commit("jpcol/uphdcolId", current.id);
    },
    gethtlist() {
      this.$http.jpcol.getcontractify().then((res) => {
        this.classifylist = res.data;
        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hdcgthtsx {
  width: 1200px;
  margin: 0 auto;
  padding: 34px 27px 0;
  background: #ffffff;
  .title {
    font-size: 26px;
    color: #333333;
    line-height: 26px;
  }
  .hdsele {
    margin-top: 24px;
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>